// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__OKqNj","label":"Radio_label__3zfO-","checkMark":"Radio_checkMark__14nmD","disabled":"Radio_disabled__1OhRi"};